import { createFileRoute } from "@tanstack/react-router";
import { OnboardingRoute } from "@/components/OnboardingRoute";
import Onboarding from "@/pages/Onboarding";

export const Route = createFileRoute("/onboarding")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <OnboardingRoute>
      <Onboarding />
    </OnboardingRoute>
  );
}
